module.exports = __webpack_public_path__ + "static/media/QRcodeBertoni-appleStore.4562da28.svg";